import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN } from './Keys';

class MixpanelManager {
  static instance = null;

  static getInstance() {
    if (!MixpanelManager.instance) {
      MixpanelManager.instance = new MixpanelManager();
    }
    return MixpanelManager.instance;
  }

  constructor() {
    console.log(' MixpanelManager Constructor Called');
    console.log(' MIXPANEL_TOKEN from env:', MIXPANEL_TOKEN);
    console.log(' Environment Variables:', {
      VITE_MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN,
      MODE: import.meta.env.MODE,
      DEV: import.meta.env.DEV,
      PROD: import.meta.env.PROD,
    });
    this.configure();
  }

  configure() {
    console.log(' Configuring Mixpanel with token:', MIXPANEL_TOKEN);
    if (!MIXPANEL_TOKEN) {
      console.error(' MIXPANEL_TOKEN is not defined! Check your .env file');
      return;
    }
    mixpanel.init(MIXPANEL_TOKEN, {
      track_pageview: true,
      persistence: 'localStorage',
      api_host: 'https://api-eu.mixpanel.com',
    });
    console.log(' Mixpanel initialized successfully');
    this.registerSuperProperties();
  }

  registerSuperProperties() {
    try {
      const superProps = {
        app_version: import.meta.env.VITE_APP_VERSION || '1.0.0',
        platform: 'Web',
        device_model: this.getDeviceModel(),
        source: 'Web',
        environment: import.meta.env.MODE || 'production',
      };
      if (mixpanel && typeof mixpanel.register === 'function') {
        mixpanel.register(superProps);
        console.log(' Mixpanel Super Properties Registered:', superProps);
      }
    } catch (error) {
      console.warn('Mixpanel register error:', error);
    }
  }

  getDeviceModel() {
    const ua = navigator.userAgent;
    if (ua.includes('Windows')) return 'Windows';
    if (ua.includes('Mac')) return 'Mac';
    if (ua.includes('Linux')) return 'Linux';
    if (ua.includes('iPhone')) return 'iPhone';
    if (ua.includes('iPad')) return 'iPad';
    if (ua.includes('Android')) return 'Android';
    return 'Unknown';
  }

  identify(userId, email = null, userName = null, userProfileImage = null) {
    try {
      if (mixpanel && typeof mixpanel.identify === 'function') {
        console.log(' Identifying User in Mixpanel');
        console.log(' User ID:', userId);
        console.log(' Email:', email);
        console.log('Name:', userName);
        
        mixpanel.identify(userId);
        
        const props = {};
        if (email) props.$email = email;
        if (userName) {
          props.$name = userName;
          props.$first_name = userName;
        }
        if (userProfileImage && userProfileImage.trim()) {
          props.$avatar = userProfileImage;
        }
        
        if (Object.keys(props).length > 0 && mixpanel.people && typeof mixpanel.people.set === 'function') {
          mixpanel.people.set(props);
          console.log('User Properties Set:', props);
        }
        console.log(' User Identified Successfully');
      }
    } catch (error) {
      console.warn('Mixpanel identify error:', error);
    }
  }

  track(eventName, properties = {}) {
    try {
      if (mixpanel && typeof mixpanel.track === 'function') {
        const eventProperties = {
          platform: 'Web',
          source: 'Web',
          timestamp: new Date().toISOString(),
          ...properties,
        };
        console.log(` [Mixpanel] Tracking Event: ${eventName}`, eventProperties);
        mixpanel.track(eventName, eventProperties);
        console.log(` [Mixpanel] Event Tracked Successfully: ${eventName}`);
      } else {
        console.warn(` [Mixpanel] mixpanel.track not available`);
      }
    } catch (error) {
      console.warn('Mixpanel track error:', error);
    }
  }

  reset() {
    try {
      if (mixpanel && typeof mixpanel.reset === 'function') {
        mixpanel.reset();
      }
    } catch (error) {
      console.warn('Mixpanel reset error:', error);
    }
  }
}

export default MixpanelManager.getInstance();
